// src/styles/GlobalStyle.js
import { createGlobalStyle } from 'styled-components';
import { colors, fonts, fontSizes } from './tokens';

export const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  html, body, #root {
    margin: 0;
    padding: 0;
    min-height: 100%;
    background: ${colors.bg};
  }

  body {
    font-family: ${fonts.sans};
    font-size: ${fontSizes.base};
    font-weight: 400;
    line-height: 1.5;
    color: ${colors.text};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    font-weight: 700;
    line-height: 1.15;
    letter-spacing: -0.01em;
  }

  p { margin: 0; }
  ul, ol { margin: 0; padding: 0; list-style: none; }

  a {
    color: inherit;
    text-decoration: none;
  }

  button {
    font: inherit;
    color: inherit;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
  }

  img, svg { display: block; max-width: 100%; }

  code, pre {
    font-family: ${fonts.mono};
  }

  /* Visible focus for keyboard users */
  :focus-visible {
    outline: 2px solid ${colors.accent};
    outline-offset: 2px;
    border-radius: 2px;
  }

  /* Reduced motion — site-wide kill-switch */
  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }

  /* Smooth anchor scrolling */
  html { scroll-behavior: smooth; }

  /* Blink for the mono caret; used across multiple components */
  @keyframes blink-caret {
    from, to { opacity: 1; }
    50% { opacity: 0; }
  }

  /* Gradient pan for signature headline */
  @keyframes gradient-pan {
    0%   { background-position: 0% 50%; }
    50%  { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
`;
